const getParameterCaseInsensitive = function (object, key) {
    const asLowercase = key.toLowerCase();
    return object[Object.keys(object).filter((k) => k.toLowerCase() === asLowercase)[0]];
};
export default getParameterCaseInsensitive;
